<template>
  <div>
    <label
      :for="inputID"
      :style="`width:${boxWidth};height:${boxHeight}`"
    >
      <b-card
        class="icon-card cursor-pointer text-center mb-2 mx-50 full-height"
        no-body
        :border-variant="variant"
      >
        <b-card-body
          class="full-height d-flex flex-column justify-content-center"
        >
          <div
            v-if="preview"
            class="d-flex flex-column justify-content-around position-relative"
            style="max-height:calc(100% - 35px)"
          >
            <b-overlay
              class="position-absolute top-center zindex-0"
              style="left:50%;"
              :show="ShowLoading"
            />
            <video
              v-if="isVideo"
              id="video"
              ref="video"
              :src="preview"
              height="90"
              class="full-width"
              style="z-index:1"
            >
              <source :src="preview">
            </video>
            <div v-else-if="isAudio" class="w-100 bg-white zindex-4">
              <feather-icon icon="MusicIcon" size="40" />
            </div>
            <img
              v-else
              :src="preview"
              style="z-index:1"
              class="full-height"
             alt="">
          </div>
          <div
            v-else
            class="icon-wrapper"
          >
            <feather-icon
              icon="UploadCloudIcon"
              size="24"
              :class="`text-${variant}`"
            />
          </div>
          <b-card-text class="icon-name text-truncate mb-0 mt-1">
            <span :class="`text-${variant}`">{{ label }}</span>
            <div
              v-if="preview !== null"
              style="position: absolute;top: 6px;left: 7px;"
            >
              <feather-icon
                v-if="!readonly"
                icon="TrashIcon"
                :class="`text-${variant} mr-1`"
                @click.prevent="removeImage"
              />
              <feather-icon
                icon="EyeIcon"
                :class="`text-${variant}`"
                @click.prevent="showImagePreview"
              />
            </div>
            <div
                v-if="fileName"
                class="w-100 position-absolute"
                style="background-color: rgba(130,130,130,0.5);right: 0;bottom: 0;white-space: initial;padding-top: 3px"
            >
              <span>{{ fileName }}</span>
            </div>
          </b-card-text>
        </b-card-body>
      </b-card>
      <input
        v-if="!readonly"
        :id="inputID"
        ref="inputFile"
        type="file"
        style="display:none"
        @input="InitImage"
      >
    </label>
    <b-modal
      v-model="showPreviewLarge"
      ok-title="بستن"
      cancel-variant="outline-info"
      centered
      ok-only
      @ok="showPreviewLarge=false"
    >
      <Div class="text-center">
        <BEmbed
          v-if="isVideo"
          type="video"
          aspect="4by3"
          controls
        >
          <source
            :src="preview"
            type="video/mp4"
          >
        </BEmbed>
        <audio v-else-if="isAudio">
          <source :src="preview" type="audio/ogg">
          <source :src="preview" type="audio/mpeg">
        </audio>
        <b-img
          v-else
          fluid
          :src="preview"
        />
      </Div>

    </b-modal>
  </div>
</template>

<script>
import { BEmbed } from 'bootstrap-vue'

export default {
  name: 'UploadFile',
  components: {
    BEmbed,
  },
  props: {
    value: { type: [File, String, Boolean], default: null },
    label: { type: String, default: 'فایل' },
    previewWidth: { type: String, default: '200px' },
    previewHeight: { type: String, default: '200px' },
    boxWidth: { type: String, default: '200px' },
    boxHeight: { type: String, default: '200px' },
    isVideo: { type: Boolean, default: false },
    isAudio: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    variant: { type: String, default: 'secondary' },
  },
  data() {
    return {
      preview: null,
      inputID: null,
      showPreviewLarge: false,
      ShowLoading: true,
      fileName: null
    }
  },
  computed: {
    previewIsVideo() {
      const regex = /(mp4|ogv|avi|flv|wmv|mov)$/gi
      if (regex.test(this.preview)) {
        return true
      }
      return false
    },
  },
  watch: {
    value(val) {
      if (val !== null) this.setImagePreview(val)
    },
    preview() {
      // if (this.isVideo) document.getElementById('video').onloadeddata = () => { this.$emit('videoData', document.getElementById('video')) }
    },
  },
  created() {
    if (this.value !== null && typeof (this.value) !== 'boolean') this.setImagePreview(this.value)
    this.inputID = String(Math.floor(Math.random() * 100) + 1)
  },
  mounted() {

  },
  methods: {
    InitImage() {
      const file = this.getFile()
      if (this.checkType(file)) this.$emit('input', file)
      this.$refs.inputFile.value = null
      this.fileName = null
    },
    getFile() {
      const { files } = this.$refs.inputFile
      if (!files.length) {
        return false
      }
      this.fileName = files[0].name
      return (files[0])
    },
    removeImage() {
      this.$emit('input', null)
      this.preview = null
    },
    setImagePreview(image) {
      if (typeof this.value === 'object') {
        this.preview = URL.createObjectURL(image)
      } else if (this.readonly) {
        this.preview = image
      }
      else {
        this.convertURltoobject()
      }
    },
    showImagePreview() {
      this.showPreviewLarge = true
    },
    checkType(file) {
      if (file.type.match('video.*') && !this.isVideo) {
        this.$bvToast.toast('عکس وارد کنید ', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return false
      }
      if (!file.type.match('video.*') && this.isVideo) {
        this.$bvToast.toast('ویدیو وارد کنید ', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return false
      }
      if (!file.type.match('audio/*') && this.isAudio) {
        this.$bvToast.toast('فایل صوتی را وارد کنید ', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return false
      }
      return true
    },
    convertURltoobject() {
      const url = this.value
      const toDataURL = urlf => fetch(new Request(urlf))
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }))

      // Here is code for converting "Base64" to javascript "File Object"

      function dataURLtoFile(dataurl, url) {
        const arr = dataurl.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], url.split('/').pop(), { type: mime })
      }

      toDataURL(url)
        .then(dataUrl => {
          const fileData = dataURLtoFile(dataUrl, url)
          this.$emit('input', fileData)
        })
    },
  },
}
</script>

<style scoped>

</style>
